<template>
<div>
  <h1 class="title">{{ $t('term.drillList') }}</h1>
  <ul v-if="drills.length > 0">
    <li
      v-for="drill in drills"
      class="block"
    >
      <div class="mt-3">
        <router-link
          :to="`/user/drills/${drill.drillId}`"
          class="is-size-5 has-text-weight-semibold"
        >{{ drill.drillId }}</router-link>
      </div>
      <div class="mt-2">
        <label class="has-text-weight-semibold">{{ $t('term.service') }}</label>
        <span>{{ drill.serviceLabel }}</span>
        <span>({{ drill.serviceId }})</span>
      </div>
      <div class="mt-2">
        <label class="has-text-weight-semibold">{{ $t('term.startedAt') }}</label>
        <span>{{ drill.startedAt | dateFormat }}</span>
      </div>
      <!--
      <div class="mt-2">
        <label class="has-text-weight-semibold">{{ $t('term.spentTime') }}</label>
        <span>{{ drill.drillTime | timeFormat }}</span>
      </div>
      -->
    </li>
  </ul>

  <div v-else-if="isLoading !== false">
    <p>{{ $t('msg["Data is empty"]') }}</p>
  </div>

  <!--
  <nav v-if="hasNext" class="u-mt2r">
    <a class="u-clickable" @click="fetchPosts({ untilTime:lastItemPublishedAt })">{{ $t('common.more') }}</a>
  </nav>
  -->
</div>
</template>

<script>
import { User } from '@/api'

export default{
  data(){
    return {
      drills: [],
    }
  },

  computed: {
  },

  async created() {
    await this.fetchDrills()
  },

  methods: {
    async fetchDrills() {
      this.$store.dispatch('setLoading', true)
      try {
        this.drills = await User.getDrills('', null, this.userToken)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err);//!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },
  },
}
</script>

